import { StyleSheet } from 'react-native';

export const COLORS = {
  primary: '#2563EB',
  primaryLight: '#3B82F6',
  primaryDark: '#1D4ED8',
  secondary: '#7C3AED',
  secondaryLight: '#8B5CF6',
  accent: '#06B6D4',
  success: '#16A34A',
  successBg: '#DCFCE7',
  warning: '#EA580C',
  warningBg: '#FFEDD5',
  danger: '#DC2626',
  dangerBg: '#FEE2E2',

  // Light Theme Tokens
  lightBg: '#F8FAFC',
  lightCard: '#FFFFFF',
  lightText: '#0F172A',
  lightSubtext: '#475569',
  lightBorder: '#E2E8F0',
  lightInputBg: '#FFFFFF',
};

export const getThemeStyles = (_isDark?: boolean) => {
  // Always enforce Light Theme
  return {
    bg: COLORS.lightBg,
    cardBg: COLORS.lightCard,
    textPrimary: COLORS.lightText,
    textSecondary: COLORS.lightSubtext,
    border: COLORS.lightBorder,
    inputBg: COLORS.lightInputBg,
  };
};

export const globalStyles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    backgroundColor: COLORS.lightBg,
  },
  centerCardContainer: {
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
  },
  card: {
    borderRadius: 20,
    padding: 24,
    backgroundColor: COLORS.lightCard,
    borderColor: COLORS.lightBorder,
    shadowColor: '#64748B',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 3,
    borderWidth: 1,
  },
  input: {
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
    fontSize: 14,
    borderWidth: 1,
    borderColor: COLORS.lightBorder,
    backgroundColor: COLORS.lightInputBg,
    color: COLORS.lightText,
    marginBottom: 12,
  },
  buttonPrimary: {
    backgroundColor: COLORS.primary,
    borderRadius: 14,
    paddingVertical: 16,
    paddingHorizontal: 20,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    shadowColor: COLORS.primary,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 4,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 15,
    fontWeight: '700',
  },
  badge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  badgeText: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.5,
  },
});
